import { render, staticRenderFns } from "./chat-support.vue?vue&type=template&id=4f294d00"
import script from "./chat-support.vue?vue&type=script&lang=js"
export * from "./chat-support.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports